import { jwtDecode } from 'jwt-decode';
import { localstorage } from './localStorageService';
import { session } from './sessionService';

const AUTH_RETURN_URL = 'authReturnUrl';
const AUTH_KEYS = [
  'ltk', 'userId', 'roleCode', 'userRoles', 'userDisplayName', 'username', 'email'
];

const rawToken = (token: string) => token.replace(/^token\s+/i, '').trim();

export const rememberCurrentUrl = () => {
  const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  if (url && url !== '/') session.setItem(AUTH_RETURN_URL, url);
};

export const clearAuthentication = (rememberUrl = false) => {
  const returnUrl = rememberUrl
    ? `${window.location.pathname}${window.location.search}${window.location.hash}`
    : null;

  session.clear();
  AUTH_KEYS.forEach(key => localstorage.removeItem(key));

  if (returnUrl && returnUrl !== '/') session.setItem(AUTH_RETURN_URL, returnUrl);
};

export const getValidAuthToken = (): string | null => {
  const sessionToken = session.getItem('id_token');
  const persistedToken = localstorage.getItem('ltk');
  const candidate = sessionToken || persistedToken;
  const userId = localstorage.getItem('userId');
  if (!candidate || !userId) return null;

  try {
    const decoded: { exp?: number } = jwtDecode(rawToken(candidate));
    // Allow a small clock-skew margin so a token cannot expire while its
    // request is travelling to the API.
    if (!decoded.exp || decoded.exp * 1000 <= Date.now() + 30000) {
      clearAuthentication(true);
      return null;
    }
  } catch {
    clearAuthentication(true);
    return null;
  }

  const formatted = `token ${rawToken(candidate)}`;
  session.setItem('id_token', formatted);
  return formatted;
};

export const hasValidAuthentication = () => !!getValidAuthToken();

export const consumeAuthReturnUrl = (): string | null => {
  const returnUrl = session.getItem(AUTH_RETURN_URL);
  if (returnUrl) session.removeItem(AUTH_RETURN_URL);
  return returnUrl;
};
